import React, { useEffect, useState } from "react";
import { Avatar, ChartsSetWrapperNew } from "../../../../../components";
import { getChartAdvMetricsLocal } from "./data";

const AreaListAdv = () => {
  const todayIso = new Date().toISOString().slice(0, 10);

  const [categories, setCategories] = useState([]);
  const [series, setSeries] = useState([]);
  const [selectedDate, setSelectedDate] = useState({
    from: null,
    to: null,
  });

  function onchange({ from, to }) {
    setSelectedDate({ from, to });
    const { categories, series } = getChartAdvMetricsLocal({ from, to });
    setCategories(categories);
    setSeries(series);
  }

  return (
    <div>
      <ChartsSetWrapperNew
        title="Line"
        type="line"
        data={series}
        categories={categories}
        options={{
          dateConfig: {
            dateFilter: true,
            dateRange: selectedDate,
            onChange: onchange,
            defaultOption: "last week",
          },
        }}
      />
      {/* <ChartsSetWrapperNew
        title="Table"
        type="table"
        data={series}
        categories={categories}
        height={500}
        options={{
          dateConfig: {
            dateFilter: true,
            dateRange: selectedDate,
            onChange: onchange,
            defaultOption: "last week",
          },
          table: {
            columns: [
              {
                key: "group",
                label: "Group",
                dataType: "string",
                render: (row) => (
                  <div className="flex items-center gap-1.5">
                    <Avatar alt={row.group} size="xs" /> {row.group}
                    {row.seriesId != null && row.seriesId !== "" ? (
                      <span className="text-xs text-gray-500">
                        ({row.seriesId})
                      </span>
                    ) : null}
                  </div>
                ),
              },
              {
                key: "category",
                label: "Duration",

                dataType: "string",
                render: (row) => <div>{row.category}</div>,
              },
            ],
          },
        }}
      /> */}
      {/* 
      <ChartsSetWrapperNew
        title="Table"
        type="table"
        data={series}
        categories={categories}
      /> */}
      {/* <ChartsSetWrapperNew
        title="Line"
        type="line"
        data={chartAdvDataNew.series}
        categories={chartAdvDataNew.categories}
        options={{
          area: {
            show: true,
          },
        }}
      /> */}
    </div>
  );
};

export default AreaListAdv;
